import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { 
        getEmployeeReferralList,
 } from "../../../../redux/employeereferral/employeeReferralState";
import { Card, Pagination} from "antd";
import { displayIcon } from "variables/icons";
import { FullDateFormat } from "utils/index";
import DownloadButton from "components/button/download";

const EmployeeReferralList = () => {
  const dispatch = useDispatch();

  const employeeReferralList = useSelector((state) => state.employeeReferral.employeeReferralList);
  const recordList = useSelector((state) => state.employeeReferral.employeeReferralList.items);
  const pagination = useSelector((state) => state.employeeReferral.employeeReferralList.pagination);
  const filters = useSelector((state) => state.employeeReferral.employeeReferralList.filters);

  useEffect(() => {
      dispatch(getEmployeeReferralList({paginate: pagination.per_page}));
  }, [dispatch, pagination]);

  const handlePageChange = (page, pageSize) => {
      dispatch(
        getEmployeeReferralList({
          ...filters,
          page,
          paginate: pageSize,
        })
      );
    };

  return (
  <div className="flex flex-col gap-4">
      
      <div className="py-5 px-4 border rounded-2xl space-y-5">

        {recordList.length > 0 ? (
          recordList.map((record) => {

        return (
          <Card
            key={record.crf_id}
            className="rounded-2xl border-2 border-slate-200 overflow-hidden 
                      bg-amber-50/30 dark:bg-amber-300/10"
          >
            <div className="flex justify-between items-start gap-4">
              <div className="title-text">
                <div className="flex items-center gap-1 text-xl">
                  {displayIcon('FileUser', "w-4 h-4")}
                  {record?.applicant_name}
                </div>
                <div className="flex items-center gap-1 muted-text">
                  {displayIcon('Phone', "w-4 h-4")}
                  {record.ref_mobile_number}
                </div>
                <div className="flex items-center gap-1 muted-text">
                  {displayIcon('Mail', "w-4 h-4")}
                  {record.ref_email}
                </div>
              </div>  
              <div className="flex flex-col justify-center gap-1">
                  <div className="title-text text-lg text-center">
                    {record.job_post_title}
                  </div>
                  <div className="text-base muted-text">
                    {record.ref_remarks}
                  </div>
                  <div className="flex w-full justify-center">
                    <DownloadButton 
                      className="text-black font-medium border bg-gradient-to-r from-white to-white hover:bg-slate-50 hover:shadow-none rounded-lg gap-1.5 h-8 px-3 text-[12px] hover:from-gray-100 hover:to-gray-100 hover:shadow-brandShadow/50" 
                      title="Download Resume"
                      type="console"
                      downloadPath={`download/employee-referral/${record?.ref_id}/resume`}/>
                  </div>
              </div>
              <div className="flex flex-col items-end">
                  <span className={`status-indicator new`}>
                      {record.status_name}
                  </span>
                  <div className="muted-text">{FullDateFormat(record?.created_at)}</div>
                  <div className="muted-text">Referred by: {record?.ref_referrer_name}</div>  
                  <div className="muted-text">Relation: {record?.relation_name}</div>
              </div>
            </div>
          </Card>
          );
        })
        ) : (
          <div className="bg-white text-slate-900 flex flex-col gap-6 rounded-xl border dark:bg-black/5">
            <div className="px-6 py-12 text-center">
              {displayIcon('CircleAlert', "w-12 h-12 text-slate-700 mx-auto mb-4 dark:text-slate-100")}
              <p className="text-slate-700 font-medium dark:text-slate-100">
                No employee referrals found
              </p>
            </div>
          </div>
        )}
    </div>
    <div className="flex justify-end mt-2">
      <Pagination
        current={employeeReferralList.pagination.current_page}
        pageSize={employeeReferralList.pagination.per_page}
        total={employeeReferralList.pagination.total}
        showSizeChanger={false}
        onChange={handlePageChange}
      />
    </div>
  </div>
  );
};

export default EmployeeReferralList;